import KpiCard from './KpiCard'
import type { ActionItemStats } from '../../types'

export default function ActionItemsKpiCard({ stats, teamId }: { stats: ActionItemStats; teamId: number }) {
  // Defensive clamp: the backend already guarantees a 0-100 weekly rate, but
  // never render an impossible percentage.
  const rate = Math.min(100, Math.max(0, stats.completion_rate))
  const hasData = stats.open_count > 0 || rate > 0
  const color = !hasData ? 'neutral' : stats.overdue_count > 0 ? 'red' : rate >= 80 ? 'green' : 'amber'
  const subtitle = stats.overdue_count > 0 ? `${stats.overdue_count} overdue` : `${stats.completed_this_week} completed this week`

  return (
    <KpiCard
      label="Action Items"
      value={hasData ? `${rate}% complete this week` : '0 items'}
      subtitle={hasData ? subtitle : 'No action items yet'}
      href={`/teams/${teamId}/action_items`}
      statusColor={color}
      icon={
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
          <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
      }
    />
  )
}
